async function setTableOrders({ commit, dispatch }, options) {
  try {
    const { response } = options;

    const syncPayload = {
      data: response.data,
      paymentConflict: options.paymentConflict || false
    };

    dispatch('socket/syncOrdersAtTable', syncPayload, { root: true });

    const { orders } = response.data;

    commit('orders/SET_ORDER_ERRORS', response.data.errors, { root: true });

    commit('orders/SET_ORDERS', orders, { root: true });

    if (orders.length > 0) {
      const selectLocationPayload = {
        location: orders[0].store,
        withMenu: true,
        silent: options.silent
      };

      await dispatch('locations/selectLocation', selectLocationPayload, { root: true });

      if (!options.dontResetIntervalSync) {
        dispatch('orders/syncOrdersAtTableIntervalStart', {}, { root: true });
      }

      await dispatch('orders/loadStagedOrderItems', {}, { root: true });
    }
    else {
      const error = new Error('no open orders');

      throw error;
    }
  }
  catch (error) {
    throw error;
  }
}

export { setTableOrders };
